<template>
    <FormInputContainer class="FormInput" :inputId="`I${_uid}`" :label="label" :errors="errors" :required="required">
        <input
            :id="`I${_uid}`"
            v-bind="$attrs"
            :type="type"
            :value="value"
            v-on="{ [lazy ? 'change' : 'input']: handleInput }"
        />
    </FormInputContainer>
</template>


<script>
import FormInputContainer from './FormInputContainer';

export default {
    name: 'FormInput',
    inheritAttrs: false,

    components: { FormInputContainer },

    props: {
        value: { type: String },
        label: { type: String },
        type: { type: String, default: 'text' },
        lazy: { type: Boolean, default: false },
        errors: { type: Array },
        required: { type: Boolean, default: false },
    },

    methods: {
        handleInput(event) {
            this.$emit('input', event.target.value);
        },
    },
}
</script>


<style lang="scss" scoped>
@import 'globals.scss';

.FormInput {
    input {
        @extend %form-control;
    }
}
</style>
